import { Dialects } from 'types/dialects';
import { PROFILE_TYPES } from 'variables';
import { ProfileType } from 'types/types';
import { formatDateFromIsoString } from '@insights-ltd/design-library/utils';

export const getPrivacyPolicyUrl = (preferredDialect: Dialects) =>
  `https://www.insights.com/${preferredDialect}/privacy-policy/`;

export const getProfileTitleText = (
  profileType: ProfileType,
  evaluationSubmittedOn: string | null,
  locale: string,
  t: (key: string) => string,
) => {
  const profileName = t(PROFILE_TYPES[profileType]);

  if (!evaluationSubmittedOn) {
    return profileName;
  }

  return `${profileName} - ${formatDateFromIsoString(
    evaluationSubmittedOn,
    locale,
  )}`;
};
